module.exports = "pegasus/assets/themelp1/charity/101.png";